import Utils from "./utils";
import mapSkin from './mapsSkin.js';


class GoogleMaps {
	/**
	 *
	 * @param options
	 */
	constructor() {

		Utils.debug('GMapsRobin ::  construct');

		this.$markers = $('.marker')
		//console.log("markers -->", this.$markers)
		this.container = $('.map-container');
		this.containerInfo = $('.map-container__infos');
		if(this.container.length === 0 ){
			Utils.debug('this is going to return');
			return;
		}

		let self = this;
		this.container.each(function(){

			let elt = $(this).find('.map-container__google').get(0);
			let infos = $(this).find('.map-container__infos').get(0);
			let zoom = $(this).find('.map-container__infos').data('zoom');

			Utils.debug(' infos elt, infos, zoom : ' + elt + ' // ' + infos + '//' + zoom)


			self.initMap({
				container : elt,
				latitude :	Number(infos.dataset.latitude),
				longitude :	Number(infos.dataset.longitude),
				url : infos.dataset.url,
				zoom : 5 //zoom
			});

		});

	}

	initMap(options) {

		Utils.debug('GmapRobin :: init');
		Utils.debug(options);




		var pixLatLng = {lat: options.latitude, lng: options.longitude};
		let myMap = new google.maps.Map(options.container, {
				zoom: options.zoom,
				center: pixLatLng,
				styles: mapSkin
			}
		);

		if ($(".marker").length === 0){
			//console.log('🚨🚨🚨🚨 marker doesnt exist')
			myMap.zoom = 9;
			let marker = new google.maps.Marker({
				position: pixLatLng,
				map: myMap,
				title: 'Pixagility',
				icon: {
					url: '../../wp-content/themes/bulb/assets/images/icons/red-pin.png',
					scaledSize: new google.maps.Size(25, 25)
				}

			});
			let zipcode = $('.map-container__infos')[0].dataset.zipcode
			let localisation = $('.map-container__infos')[0].dataset.localisation
			let adress = $('.map-container__infos')[0].dataset.adress
			let tel = $('.map-container__infos')[0].dataset.tel

			const contentWindow = `
<p><strong>${localisation}</strong></p>
<p> ${adress}</p>
<p>${zipcode}</p>
<p>${tel}</p>`


			const infowindow = new google.maps.InfoWindow({
				content: contentWindow,
			});

			marker.addListener("click", () => {
				myMap.setZoom(12)
				infowindow.open(myMap, marker);
			});

		}

		else{

			//console.log('marker exist 🚨🚨🚨🚨')

			/// 🚨🚨SIEGE  SOCIAL 🚨🚨  /////

			var lat = this.containerInfo[0].dataset.latitude;
			var lng = this.containerInfo[0].dataset.longitude;
			var latLng = {
				lat: parseFloat( lat ),
				lng: parseFloat( lng )
			};

			//console.log(latLng,'siege lat')

			let siege = new google.maps.Marker({
				position : latLng,
				map: myMap,
				icon: {
					url: '../../wp-content/themes/bulb/assets/images/icons/red-pin.png',
					scaledSize: new google.maps.Size(25, 25)
				}
			});

			let zipcode = this.containerInfo[0].dataset.zipcode
			let localisation = this.containerInfo[0].dataset.localisation
			let adress = this.containerInfo[0].dataset.adress
			let tel = this.containerInfo[0].dataset.tel

			const contentWindow = `
<p><strong>${localisation}</strong></p>
<p> ${adress}</p>
<p> ${zipcode}</p>
<p> ${tel}</p>`


			const infowindow = new google.maps.InfoWindow({
				content: contentWindow,
			});

			siege.addListener("click", () => {
				myMap.setZoom(12)
				infowindow.open(myMap, siege);
			});

			myMap.markers = [];
			// Append to reference for later use.
			myMap.markers.push( siege );

			/// 🚨🚨SIEGE  SOCIAL 🚨🚨  /////

			this.$markers.each((i,el)=>{
				//console.log(el)
				var lat = el.dataset.lat;
				var lng = el.dataset.lng;
				var latLng = {
					lat: parseFloat( lat ),
					lng: parseFloat( lng )
				};

				let zipcode = el.dataset.zipcode
				let localisation = el.dataset.localisation
				let adress = el.dataset.adress
				let tel = el.dataset.tel

				const contentWindow = `
<p><strong>${localisation}</strong></p>
<p> ${adress}</p>
<p> ${zipcode}</p>
<p> ${tel}</p>`

					var marker = new google.maps.Marker({
						position : latLng,
						map: myMap,
						icon: {
							url: '../../wp-content/themes/bulb/assets/images/icons/black-pin.png',
							scaledSize: new google.maps.Size(25, 25)
						}
					});

				// }

				const infowindow = new google.maps.InfoWindow({
					content: contentWindow,
				});

				marker.addListener("click", () => {
					myMap.setZoom(12)
					infowindow.open(myMap, marker);
				});

				myMap.markers = [];
				// Append to reference for later use.
				myMap.markers.push( marker );

			})

		}

	}


}

module.exports = GoogleMaps;


